import { render, staticRenderFns } from "./SubmitWorks.vue?vue&type=template&id=44da3586&scoped=true"
import script from "./SubmitWorks.vue?vue&type=script&lang=js"
export * from "./SubmitWorks.vue?vue&type=script&lang=js"
import style0 from "./SubmitWorks.vue?vue&type=style&index=0&id=44da3586&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44da3586",
  null
  
)

export default component.exports